<template>
  <div id="Efficacy">
    <div class="statistical">
      <van-row>
        <van-col span="12">
          <div class="statistical-card">
            <p><span>{{allStatistics.maxVisits}}</span> 次</p>
            <p>单日最高访问次数</p>
            <div class="statistical-card-icon"><van-icon class="iconfont" class-prefix="icon" name="anquanshezhi"></van-icon></div>
            <div class="waves"><img src="../../assets/image/efficacy/waves01.png" alt=""></div>
          </div>
        </van-col>
        <van-col span="12">
          <div class="statistical-card">
            <p><span>{{allStatistics.totalVisits}}</span> 次</p>
            <p>累计访问次数</p>
            <div class="statistical-card-icon"><van-icon class="iconfont" class-prefix="icon" name="icon"></van-icon></div>
            <div class="waves"><img src="../../assets/image/efficacy/waves01.png" alt=""></div>
          </div>
        </van-col>
        <van-col span="12">
          <div class="statistical-card">
            <p><span>{{allStatistics.sendFlowUsers}}</span> 人</p>
            <p>累计服务人数</p>
            <div class="statistical-card-icon"><van-icon class="iconfont" class-prefix="icon" name="fuwu11"></van-icon></div>
            <div class="waves"><img src="../../assets/image/efficacy/waves01.png" alt=""></div>
          </div>
        </van-col>
        <van-col span="12">
          <div class="statistical-card">
            <p><span>{{allStatistics.flowSendCount}}</span> 次</p>
            <p>累计服务次数</p>
            <div class="statistical-card-icon"><van-icon class="iconfont" class-prefix="icon" name="fuwu1"></van-icon></div>
            <div class="waves"><img src="../../assets/image/efficacy/waves01.png" alt=""></div>
          </div>
        </van-col>
        <van-col span="24">
          <div class="statistical-card">
            <p>不足 <span>{{allStatistics.minHandleTime == 0? 1 : allStatistics.minHandleTime}}</span> 分钟</p>
            <p>最短审核耗时</p>
            <div class="statistical-card-icon"><van-icon class="iconfont" class-prefix="icon" name="shijian"></van-icon></div>
            <div class="waves"><img src="../../assets/image/efficacy/waves02.png" alt=""></div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div class="statistical-tab">
      <div class="card-bg">
        <van-tabs animated v-model="active" :title-active-color="'var(--main-color)'" :color="'var(--main-color)'" @click="onClick">
          <van-tab title="服务进驻情况">
            <van-row gutter="10">
              <van-col span="8">
                <dl>
                  <dt>{{allStatistics.totalCount}}</dt>
                  <dd>服务(个)</dd>
                </dl>
              </van-col>
              <van-col span="8">
                <div class="chart">
                  <van-circle
                      v-model="handleRatio"
                      size="100px"
                      layer-color="#e1e7f0"
                      :color="'var(--main-color)'"
                      :rate="handleRatioRate"
                      :speed="100"
                      :stroke-width="150"
                      :text="handleRatioRate + '%'"/>
                </div>
                <dl>
                  <dt></dt>
                  <dd>网上可办比</dd>
                </dl>
              </van-col>
              <van-col span="8">
                <dl>
                  <dt>{{allStatistics.onlineCount}}</dt>
                  <dd>线上可办服务(个)</dd>
                </dl>
              </van-col>
            </van-row>
          </van-tab>
          <van-tab title="事项办理结果">
            <van-row gutter="10">
              <van-col span="8">
                <dl>
                  <dt>{{allStatistics.flowSendCount - allStatistics.flowEndCount}}</dt>
                  <dd>办理中事项(个)</dd>
                </dl>
              </van-col>
              <van-col span="8">
                <div class="chart">
                  <van-circle
                      v-model="flowEndRatio"
                      size="100px"
                      layer-color="#e1e7f0"
                      :color="'var(--main-color)'"
                      :rate="onlineFlowEnd"
                      :speed="100"
                      :stroke-width="150"
                      :text="onlineFlowEnd + '%'"/>
                </div>
                <dl>
                  <dt></dt>
                  <dd>网上办结率</dd>
                </dl>
              </van-col>
              <van-col span="8">
                <dl>
                  <dt>{{allStatistics.flowEndCount}}</dt>
                  <dd>办结事项(个)</dd>
                </dl>
              </van-col>
            </van-row>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-list
        v-model="isLoading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getEfficacy"
        v-if="!emptyShow"
    >
      <div class="statistical-list">
        <div class="card-bg">
          <div id="enter-situation">
            <ul v-if="active == 0">
              <li v-for="(item, index) in list" :key="index">
                <h2>{{ item.deptName }}</h2>
                <p>
                  <span>服务总数:{{ item.totalCount }}</span>
                  <span>线上可办服务:{{ item.onlineCount }}</span>
                  <span>线下可办服务:{{ item.totalCount - item.onlineCount }}</span>
                  <span>网上可办比:{{ isNaN((item.onlineCount / item.totalCount * 100).toFixed(2)) ? 0 : (item.onlineCount / item.totalCount * 100).toFixed(2) }}%</span>
                </p>
              </li>
            </ul>
            <ul v-if="active == 1">
              <li v-for="(item, index) in list" :key="index">
                <h2>{{ item.deptName }}</h2>
                <p>
                  <span>办理中事项:{{ item.flowSendCount - item.flowEndCount }}</span>
                  <span>办结事项:{{ item.flowEndCount }}</span>
                  <span>平均耗时:{{ item.elapsedTime }}</span>
                  <span>网上办结率:{{ (item.flowProcessingRate*100).toFixed(2) }}%</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </van-list>
    <Error :type="'empty'" v-else></Error>
  </div>
</template>

<script>
  import {Circle} from 'vant';
  import {getEfficacyData, getEfficacyEnterCase, getEfficacyHandleResults} from "@/api/efficacy";
  import {List} from 'vant';
  export default {
    name: "Efficacy",
    components: {
      'van-circle': Circle,
      [List.name]:List
    },
    data () {
      return {
        active: 0,
        allStatistics: {},
        handleRatio: 0,
        flowEndRatio: 0,
        handleRatioRate: 0,
        onlineFlowEnd: 0,
        enterSituation: true,
        handleSupervision: false,
        count:0,
        isLoading:false,
        finished: false,
        list: [],//列表显示的数据
        params: {
          pageIndex: 0,
          pageSize: 5
        },
        total: 0,
        totalPage: 0,
        currentPage: 0,
        emptyShow: false
      }
    },
    created() {
      window.history.pushState(null, null, document.URL)
      this.init();
    },
    methods: {
      init() {
        getEfficacyData().then(resp => {
          if (resp.code && resp.code == 200) {
            if(resp.data){
              this.allStatistics   = resp.data;
              this.handleRatioRate = (this.allStatistics.onlineCount / this.allStatistics.totalCount * 100).toFixed(2);
              this.handleRatioRate = isNaN(this.handleRatioRate) ? 0 : this.handleRatioRate;
              this.onlineFlowEnd   = (this.allStatistics.flowProcessingRate * 100).toFixed(2);
            }
          }
        });
        this.getEfficacy();
      },
      getEfficacy() {
        this.emptyShow = false;
        this.isLoading = true;
        if( this.active == 0 ) {
          this.finished = false;
          getEfficacyEnterCase(this.params).then(resp => {
            if(resp.code && resp.code == 200){
              if (this.params.pageIndex == 0) {
                this.list = resp.data.data || [];
              } else {
                if(resp.data.data) {
                  resp.data.data.forEach( item => {
                    this.list.push(item)
                  })
                }
              }
              this.total = resp.data.total;
              this.totalPage = resp.data.totalPage;
              this.isLoading = false;
              this.list.length > 0? this.emptyShow = false : this.emptyShow = true
              if (this.params.pageIndex >= this.totalPage) {
                this.finished = true;
              } else {
                this.params.pageIndex++;
              }
            }
          })
        } else if(this.active == 1) {
          this.finished = false;
          getEfficacyHandleResults(this.params).then(resp => {
            if(resp.code && resp.code == 200){
              let result = resp.data;
              result.data.forEach(item => {
                item.elapsedTime = this.getDuration(item.elapsedTime / item.flowEndCount);
              })
              if (this.params.pageIndex == 0) {
                this.list = result.data || [];
              } else {
                if(result.data) {
                  result.data.forEach( item => {
                  this.list.push(item);
                  })
                }
              }
              this.total = resp.data.total;
              this.totalPage = resp.data.totalPage;
              this.isLoading = false;
              if (this.params.pageIndex >= this.totalPage) {
                this.finished = true;
              } else {
                this.params.pageIndex++;
              }
            }
          });
        }
      },
      onClick: function () {
        this.params.pageIndex = 0;
        this.list = [];
        this.totalPage = 0;
        this.total = 0;
        this.getEfficacy();
      },
      getDuration: function (second) {
        if (!second || second == Infinity || second == -Infinity) {
          return '-';
        }
        var duration = '';

        var years = Math.floor(second / (86400 * 30 * 12));
        var month = Math.floor((second % (86400 * 30 * 12)) / (86400 * 30));
        var days = Math.floor((second % (86400 * 30)) /86400);
        var hours = Math.floor((second % 86400) / 3600);
        var minutes = Math.floor(((second % 86400) % 3600) / 60);
        var seconds = Math.ceil(((second % 86400) % 3600) % 60);
        if (seconds > 0) {
          minutes += 1;
        }

        if (years > 0) {
          duration += years + "年";
        }

        if (month > 0) {
          duration += month + "个月";
        }

        if (days > 0) {
          duration += days + "天";
        }

        if (hours > 0) {
          duration += hours + "小时";
        }

        if (minutes > 0) {
          duration += minutes + "分钟";
        }

        return duration;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/theme/theme";
  .statistical {
    padding: 6px 9px;

    .statistical-card {
      position: relative;
      height: 92px;
      margin: 6px;
      padding: 15px;
      box-sizing: border-box;
      border-radius: 6px;
      background: var(--main-color);

      p {
        position: relative;
        z-index: 999;
        color: #fff;
        line-height: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @extend .font14;

        span {
          @extend .font22;
        }
      }
      .statistical-card-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        z-index: 998;
        width: 32px;
        height: 32px;
        margin-top: -16px;

        i {
          display: block;
          width: 100%;
          height: 100%;
          font-size: 30px;
          color: #fff;
          text-align: center;
          line-height: 32px;
          opacity: .4;
        }
      }

      .waves {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 997;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .statistical-tab {
    padding: 0 15px 6px;
    background: #f7f7f7;

    .card-bg {
      border-radius: 6px;
      padding: 0 15px 15px;
      background: #fff;
      overflow: hidden;

      .van-col {
        position: relative;
        height: 180px;

        .chart {
          padding-top: 40px;
        }

        dl {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          text-align: center;
          line-height: 24px;

          dt {
            margin-bottom: 5px;
            color: $c333;
            @extend .font18;
          }

          dd {
            color: $c999;
            @extend .font12;
          }
        }
      }
    }
  }
  .statistical-list {
    padding: 6px 15px 0;
    margin-bottom: 12px;
    .card-bg {
      border-radius: 6px;
      padding: 15px;
      background: #fff;
      overflow: hidden;
      ul {
        li {
          padding: 20px 0 12px 0;
          border-bottom: 1px solid #e5e5e5;
          &:last-child {
            border-bottom: none;
          }
          h2 {
            margin-bottom: 10px;
            color: $c333;
            line-height: 25px;
            @extend .font18;
          }
          p {
            overflow: hidden;
            clear: both;
            span {
              display: block;
              float: left;
              height: 24px;
              padding: 0 6px;
              margin-bottom: 8px;
              margin-right: 5px;
              border-radius: 4px;
              color: var(--main-color);
              line-height: 24px;
              background: rgba(var(--rgb-main-color), .1);
              @extend .font12;
              &:last-of-type{
                margin-right: 0
              }
            }
          }
        }
      }
    }
  }
  .empty{
    margin-top: 100px;
  }
</style>
